module.exports = __webpack_public_path__ + "static/media/youtubeC.1329c986.png";